var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteDeposit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/deposit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/deposit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(2.0029, 0.9825)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(11.9172, 13.0725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0799409,0 L14.0799409,13.9450049 L13,13.9450049 L13,0.945004876 L1,0.945004876 L1,13.9450049 L0,13.9450049 L0,0 L14.0799409,0 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5199516,2.53545543 L11.5199516,13.9450049 L10.175945,13.9450084 C10.2179215,13.7401996 10.239957,13.528219 10.239957,13.311141 C10.239957,11.5607743 8.80727423,10.1418217 7.03997045,10.1418217 C5.27266667,10.1418217 3.83998388,11.5607743 3.83998388,13.311141 C3.83998388,13.5285691 3.86209055,13.7408834 3.9041992,13.9459994 L3.90398926,13.9444554 L2.55998926,13.9450049 L2.55998926,2.53545543 L11.5199516,2.53545543 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(-0, -0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94799102,-0.171514676 L3.74916942,-0.182083963 C3.21612176,-0.184631781 2.79615669,0.236046955 2.79871045,0.769990057 L2.83495923,8.31193637 C2.83752469,8.84587947 3.26155174,9.27061065 3.7945994,9.27317008 L5.993421,9.28372775 L5.94799102,-0.171514676 L5.94799102,-0.171514676 Z",
    id: "Path",
    transform: "translate(4.3961, 4.5508) scale(1, -1) rotate(-43) translate(-4.3961, -4.5508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66187859,2.53299541 C11.465244,4.08939421 12.6436709,5.06711528 13.1971591,5.4661586 C15.6777022,7.25453278 16.4763652,7.48369184 17.037143,8.00161403 C18.7593462,9.59220346 20.226157,11.2823193 21.4375753,13.0719615 L13.7551002,13.0719954 L12.4769482,11.891435 C12.0965485,11.5401061 11.4767779,11.5415347 11.0909761,11.9184503 C10.6730645,12.3294694 10.6827489,12.9760083 11.0796877,13.3426124 L15.4129365,17.3447067 C16.2895097,18.1542907 16.440223,19.5049159 15.7542203,20.5290846 C15.5946397,20.7642562 15.41852,20.9841527 15.2098064,21.2058257 C14.8244888,21.6150683 14.2052025,21.6488238 13.8082637,21.2822197 L11.4266308,19.0825953 C10.6492922,18.3646624 9.56787907,18.035367 8.40473876,17.6943496 C7.19246531,17.3398337 5.94711363,16.9547675 4.89054699,16.1064644 C3.94975418,15.3650875 3.16951035,14.4531929 2.55029973,13.4031075 C1.89752665,12.2901448 2.022652,10.8436011 2.85508566,9.7952742 C2.85508566,9.7952742 2.85508566,9.7952742 2.83854654,9.77999903 L9.66187859,2.53299541 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteDeposit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-deposit.2de9d4201eddc4e1376af3191d8bee66.svg";